import {Component, EventEmitter, Output} from '@angular/core';

@Component({
    selector: 'ribbon',
    template:`
        <div class="ribbon">
            <ul class="ribbon-group">
                <li class="ribbon-group-col">
                    <div class="ribbon-btn-vertical" (click)="onNewEmail()">
                        <div class="ribbon-btn" >
                            <i class="ribbon-ico-32 ribbon-ico-save"></i>
                            <h6>New Email</h6>
                        </div>
                    </div>
                </li>
                <li class="ribbon-group-col">
                    <div class="ribbon-btn-horizontal">
                        <div class="ribbon-btn"><i class="ribbon-ico-16 ribbon-ico-undo"></i> Undo</div>
                    </div>
                    <div class="ribbon-btn-horizontal">
                        <div class="ribbon-btn"><i class="ribbon-ico-16 ribbon-ico-redo"></i> Redo</div>
                    </div>
                </li>
                <li class="ribbon-group-col">
                    <div class="ribbon-btn-vertical">
                        <div class="ribbon-btn">
                            <i class="ribbon-ico-32 ribbon-ico-properties"></i>
                            <h3 class="ribbon-btn-label">Properties</h3>
                        </div>
                    </div>
                </li>
                <li class="ribbon-group-col">
                    <div class="ribbon-btn-vertical">
                        <div class="ribbon-btn">
                            <i class="ribbon-ico-32 ribbon-ico-copy-from"></i>
                            <h3 class="ribbon-btn-label">Copy From</h3>
                        </div>
                    </div>
                </li>
                <li class="ribbon-group-col">
                    <div class="ribbon-btn-vertical">
                        <div class="ribbon-btn">
                            <i class="ribbon-ico-32 ribbon-ico-actions-and-validations"></i>
                            <h3 class="ribbon-btn-label">Actions & Validations</h3>
                        </div>
                    </div>
                </li>
                <p class="ribbon-group-label">Form</p>
            </ul>
            <ul class="ribbon-group">
                <li class="ribbon-group-col">
                    <div class="ribbon-btn-horizontal">
                        <div class="ribbon-btn"><i class="ribbon-ico-16 ribbon-ico-convert-to"></i> Convert To <i class="ribbon-btn-caret"></i></div>
                    </div>
                    <div class="ribbon-btn-horizontal">
                        <div class="ribbon-btn"><i class="ribbon-ico-16 ribbon-ico-delete"></i> Delete</div>
                    </div>
                    <div class="ribbon-btn-horizontal">
                        <div class="ribbon-btn"><i class="ribbon-ico-16 ribbon-ico-rename"></i> Rename</div>
                    </div>
                </li>
                <p class="ribbon-group-label">Element</p>
            </ul>
            <ul class="ribbon-group">
                <li class="ribbon-group-col">
                    <div class="ribbon-btn-horizontal">
                        <div class="ribbon-btn"><i class="ribbon-ico-16 ribbon-ico-visible"></i> Visible <i class="ribbon-btn-caret"></i></div>
                    </div>
                    <div class="ribbon-btn-horizontal">
                        <div class="ribbon-btn"><i class="ribbon-ico-16 ribbon-ico-editable"></i> Editable</div>
                    </div>
                    <div class="ribbon-btn-horizontal">
                        <div class="ribbon-btn"><i class="ribbon-ico-16 ribbon-ico-required"></i> Required <i class="ribbon-btn-caret"></i></div>
                    </div>
                </li>
                <p class="ribbon-group-label">Visual</p>
            </ul>
        </div>`,
    styles:[`
    .ribbon {
        overflow: hidden;
        width: 100%;
        height: 87px;
        border: 1px solid;
        border-color: #6b7b84 #596775 #8b9097;
        box-shadow: #aeb1b6 0 2px 2px; /* inset is optional */
        background: -webkit-linear-gradient(top, #fff, #f9f9f9 45%, #e5e9ee);
    }

    .ribbon-group {
        position: relative;
        float: left;
        margin-right: 1px;
        padding: 2px 4px;
        height: 85px;
        border-width: 1px;
        list-style: none;
        -webkit-border-image: -webkit-linear-gradient(#fdfdfd, #fff) 1 100%;
    }

    /*.ribbon-group::before
    {
      content: "";
      position: absolute;
      left: 2px;
      z-index: 0;
      width: 100%;
      height: 100%;
    \tbackground: -webkit-radial-gradient(center bottom, circle cover, #fff 20px, rgba(229, 233, 238, 0) 100px, rgba(255, 255, 255, 0));
      opacity: 0;
      -webkit-transition: opacity ease-in .4s;
      opacity: 0;
    }*/
    .ribbon-group::after {
        content: "";
        position: absolute;
        top: 0;
        right: -2px;
        width: 1px;
        height: 100%;
        background: -webkit-linear-gradient(top, #f6f7f8, #c6cad0 45%, #b0b6bc);
    }

    .ribbon-group:hover {
        background: -webkit-radial-gradient(center bottom, circle cover, #fff 20px, rgba(229, 233, 238, 0) 100px, rgba(255, 255, 255, 0));
    }

    .ribbon-group-col {
        float: left;
    }

    .ribbon-group-label {
        clear: left;
        text-align: center;
        color: #966d91;
    }

    .ribbon-btn-horizontal {
        height: 22px;
    }

    .ribbon-btn-horizontal > .ribbon-btn {
        border: 1px solid transparent;
        border-radius: 3px;
    }

    .ribbon-btn-horizontal > .ribbon-btn:hover {
        border-color: #f0cb54;
    }

    .ribbon-btn-vertical {
        height: 66px;
        border: 1px solid transparent;
        border-radius: 3px;
        text-align: center;
    }

    .ribbon-btn-vertical:hover {
        border-color: #f0cb54;
    }

    .ribbon-btn-vertical > .ribbon-btn:last-child {
        line-height: 12px;
    }

    .ribbon-btn-vertical > .ribbon-btn > i {
        margin-bottom: 2px;
    }

    .ribbon-btn-vertical > .ribbon-btn > h3 {
        margin-top: 2px;
    }

    .ribbon-btn {
        padding: 2px 4px;
        min-height: 100%;
        cursor: pointer;
    }

    .ribbon-btn:hover {
        background: -webkit-linear-gradient(top, #fcedb2, #fce289 30%, #fce289 60%, #fdfae0);
        box-shadow: #fdf6dc 0 0 0 1px inset;
    }

    .ribbon-btn-caret {
        display: inline-block;
        width: 0;
        height: 0;
        vertical-align: super;
        border-top: 3px solid #000;
        border-right: 3px solid transparent;
        border-left: 3px solid transparent;
        content: "";
    }

    .ribbon-btn > h3[class^="ribbon-btn-label"] {
        text-align: center;
    }

    .ribbon-btn-label-copy-from {
        width: 3em;
    }

    [class^="ribbon-ico"], [class*=" ribbon-ico"] {
        display: inline-block;
        vertical-align: bottom;
    }

    .ribbon-ico-32 {
        width: 32px;
        height: 32px;
    }

    .ribbon-ico-16 {
        width: 16px;
        height: 16px;
    }

    .ribbon-ico-copy-from + h3 {
        max-width: 3.5em;
    }

    .ribbon-ico-actions-and-validations + h3 {
        max-width: 5em;
    }

    .ribbon-ico-undo {
        background-position: -128px 0;
    }

    .ribbon-ico-redo {
        background-position: -128px -32px;
    }

    .ribbon-ico-properties {
        background-position: -32px 0;
    }

    .ribbon-ico-copy-from {
        background-position: -64px 0;
    }

    .ribbon-ico-actions-and-validations {
        background-position: -96px 0;
    }

    .ribbon-ico-convert-to {
        background-position: -144px 0;
    }

    .ribbon-ico-delete {
        background-position: -144px -32px;
    }

    .ribbon-ico-rename {
        background-position: -160px 0;
    }

    .ribbon-ico-visible {
        background-position: -160px -32px;
    }

    .ribbon-ico-editable {
        background-position: -176px 0;
    }

    .ribbon-ico-required {
        background-position: -176px -32px;
    }

    .ribbon-ico-data,
    .ribbon-ico-controls,
    .ribbon-ico-layout {
        vertical-align: text-top;
    }

    .ribbon-ico-data {
        background-position: -192px 0;
    }

    .ribbon-ico-controls {
        background-position: -192px -32px;
    }

    .ribbon-ico-layout {
        background-position: -208px 0;
    }

    #container-layout {
        position: relative;
        height: 100%;
    }

    .wrapper-left-panel {
        position: fixed;
        margin-top: 90px;
        padding: 2px 7px;
        width: 300px;
        height: 100%;
        border: 1px solid #8a9096;
        background-color: #e9edf1;
    }

    .ui-tabs-nav {
        border-bottom: 1px solid #bbbfc4;
        list-style: none;
    }

    .ui-tabs-nav::before,
    .ui-tabs-nav::after,
    .wrapper-main-panel::before,
    .wrapper-main-panel::after {
        display: table;
        content: "";
    }

    .ui-tabs-nav::before,
    .ui-tabs-nav::after,
    .wrapper-main-panel::before,
    .wrapper-main-panel::after {
        clear: both;
    }


    .ui-tabs-nav > li {
        float: left;
        margin-bottom: -1px;
    }

    .ui-tabs-nav > li > a {
        display: block;
        padding: 4px;
        line-height: 24px;
        border: solid #bbbfc4;
        border-width: 1px 1px 1px 0;
        border-bottom-color: transparent;
        text-decoration: none;
        color: #000;
        -webkit-transition: box-shadow ease-in .4s;
    }

    .ui-tabs-nav > li > a:hover {
        box-shadow: #fff 0 1px 1px 1px inset;
    }

    .ui-tabs-nav > li:first-child > a {
        border-left-width: 1px;
    }

    .ui-tabs-nav > .active > a {
        background-color: white;
        cursor: default;
    }

    .ui-tabs-panel {
        clear: left;
        padding: 22px;
        border: solid #bbbfc4;
        border-width: 0 1px 1px;
        background-color: #fff;
    }

    .wrapper-main-panel {
        padding: 110px 30px 0 330px;
        height: 100%;
    }

    #main-panel {
        padding: 2%;
        height: 90%;
        border: 1px solid #a9b0b8;
        background-color: #fff;
        box-shadow: #9b9ea2 0 5px 10px 1px;
    }`]
})
export class RibbonComponent {

    @Output() newEmail: EventEmitter<any> = new EventEmitter();
    constructor() {

    }

    onNewEmail() {
        this.newEmail.emit();
    }
}
